module.exports = __webpack_public_path__ + "static/media/appStore.f88d2709.svg";